module.exports = __webpack_public_path__ + "static/media/galeria2.2f87e864.jpg";